import React, {useEffect, useRef, useState} from "react";
import Grid from "@material-ui/core/Grid";
import Drawer from "@material-ui/core/Drawer";
import Aux from "../../../hoc/Auxiliary/Auxiliary";
import Button from "../../UI/Button/Button";
import AccTable from "../CommercialCPs/ListOfCvs/ListOfCvs"
import classes from "./Commercial.module.css";
import Opportunity from "./Opportunity/Opportunity";
import {
    deleteClient,
    deleteFile,
    deleteOpportunity,
    searchFileByKey,
    searchFileContentByFileId,
    searchMembersByGroupId
} from "../../../graph-services/GraphServices";
import _ from "lodash";
import SearchData from "../SearchData/SearchData";
import CvDetails from "../CvDetails/CvDetails";
import {getElementFromSkills, getLanguageFromFileName} from "../utils";
import {generateDocument} from "../../FileGenerator/DocumentFileGenerator";
import MenuItems from "../../UI/MenuItems/menuItems";
import {FileExtensionEnum} from "../../../Enumerations/FileExtensionEnum";
import PizZip from "pizzip";
import {saveAs} from "file-saver";

let Element = (props) => {
    let searchKeys = useRef("");
    let [count, setCount] = useState(0);
    const [files, setFiles] = useState([]);
    let [selectedOpportunity, setSelectedOpportunity] = useState(null)
    let [isDataLoaded, setIsDataLoaded] = useState(false)
    let [checkedList, setCheckedList] = React.useState([]);
    let [anchorEl, setAnchorEl] = React.useState(null);
    const [rowsPerPage, setRowsPerPage] = React.useState(25);
    const [page, setPage] = React.useState(0);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function findElementIndexInArray(list, item) {
        return list.findIndex(object => {
            return object.fileId === item;
        });
    }

    function addIndexToDuplicates(elementsMap) {
        let counts = {};
        let indexTracker = {};

        for (let key in elementsMap) {
            let fileName = elementsMap[key].fileName;
            counts[fileName] = (counts[fileName] || 0) + 1;
            indexTracker[fileName] = 1;
        }

        for (let key in elementsMap) {
            let fileName = elementsMap[key].fileName;
            let count = counts[fileName];

            if (count > 1) {
                let index = indexTracker[fileName];
                elementsMap[key].fileName = `${fileName}_(${index})`;
                indexTracker[fileName]++;
                counts[fileName]--;
            }
        }
        return elementsMap;
    }

    async function downloadSelectedDocuments(documentType) {
        let zipFile = checkedList.length === 1 ? null : new PizZip();
        if (checkedList.length !== 0) {
            addIndexToDuplicates(checkedList)
            await Promise.all(checkedList.map(async (selectedFile) => {
                setAnchorEl(null)
                const content = await searchFileContentByFileId(props.access_token, props.siteId, selectedFile.fileId)
                content.SkillsPassport.LearnerInfo.EducationAndTraining = getElementFromSkills(content.SkillsPassport.LearnerInfo.EducationAndTraining)
                const language = getLanguageFromFileName(selectedFile.fileName)
                await generateDocument(props.access_token, props.webUrl, props.siteId, selectedFile.fileName, language, content, props, documentType, zipFile)
                setCheckedList([])
            }))
        }

        if (zipFile !== null) {
            var zipContent = zipFile.generate({type: "blob"});
            saveAs(zipContent, "QwickCV_" + new Date().toISOString() + ".zip");
            props.onLoading(false);
            props.notify("The Consultant Profiles have been generated !", "success");
        }
    }

    // Initialize Sales Members
    let [salesMembers, setSalesMembers] = useState(Array);
    useEffect(() => {
        if (_.isEmpty(salesMembers) && (props.access_token !== "") && (props.salesGroupId !== "")) {
            searchMembersByGroupId(props.access_token, props.salesGroupId)
                .then(members => {
                    setSalesMembers(members)
                })
        }
    }, [props.salesGroupId, salesMembers])

    // Handle Add New Opportunity Button
    let addNewOpportunity = async () => {
        props.changeLanguage(props.defaultLanguage.code)
        setSelectedOpportunity(null)
        setIsOpenOpportunityDrawer(true)
    }

    // Add New Opportunity Button & Clone CP Button
    let hasSalesFunctionalities = props.isSalesMember || props.isAdminMember;

    useEffect(async () => {
        if (props.webUrl && props.webUrl !== "") {
            handleLoading(true)
            await reloadSalesData(searchKeys.current)
            handleLoading(false)
        }
    }, [])

    // pass reloadSalesData() function to the 'Home' parent component
    useEffect(() => props.setReloadCommercial(() => () => searchFileByKey(props.access_token, props.siteId, props.listId, props.webUrl, searchKeys.current, "Sales", false)
        .then(files => {
            let data = []
            if (Array.isArray(files)) {
                files.map(f => data.push(f))
            }
            setFiles(data)
        })), [])

    useEffect(() => {
        setTimeout(() => {
            setCount(count + 1);
        }, process.env.REACT_APP_RELOAD_DELAY);
    
    });

    // pass commercialData to the 'Home' parent component
    useEffect(() => {
        if (files.length) {
            props.setCommercialData(files)
        }
    }, [files])

    useEffect(() => {
            if (props.listId && props.listId !== "" && props.webUrl !== "") {
                reloadSalesData(searchKeys.current)
            }
        }, [props.webUrl, count])

    let reloadSalesData = async (searchSalesKey = searchKeys.current) => {
        return searchFileByKey(props.access_token, props.siteId, props.listId, props.webUrl, searchSalesKey, "Sales", false)
            .then(files => {
                let data = []
                if (Array.isArray(files)) {
                    files.map(f => data.push(f))
                }
                setFiles(data)
                setIsDataLoaded(true)
                props.setIsCommercialCPsLoaded(true)
            })
    }

    let commercialCvsBtnArea = (
        <Aux>
            {hasSalesFunctionalities && <Grid container spacing={3}>
                <Grid item xs={2}>
                    <Button
                        label="ADD NEW OPPORTUNITY"
                        variant="success"
                        isVisible={hasSalesFunctionalities}
                        actionHandler={() => addNewOpportunity()}
                    />
                </Grid>
                <Grid item xs={2}>
                    <MenuItems
                        handleClick={handleClick}
                        handleClose={handleClose}
                        anchorEl={anchorEl}
                        isDisabledButton={checkedList.length === 0}
                        menuItems={[
                            {
                                label: "Save as " + FileExtensionEnum.DOCX,
                                onClick: () => downloadSelectedDocuments(FileExtensionEnum.DOCX)
                            },
                            {
                                label: "Save as " + FileExtensionEnum.PDF,
                                onClick: () => downloadSelectedDocuments(FileExtensionEnum.PDF)
                            }
                        ]}
                    />

                </Grid>
            </Grid>}
        </Aux>
    )

    let handleLoading = (v) => {
        props.onLoading(v);
    }

    // Handle Opportunity Drawer
    let [isOpenOpportunityDrawer, setIsOpenOpportunityDrawer] = useState(false);

    let closeOpportunityDrawer = () => {
        setIsOpenOpportunityDrawer(false)
        setCount(count + 1);
    }

    let opportunityDrawer = (
        <Drawer
            classes={{ paper: classes.halfPaper }}
            anchor="right"
            open={isOpenOpportunityDrawer}
            onClose={closeOpportunityDrawer}>

            {/* Edit opportunity form */}
            <Opportunity
                element={selectedOpportunity}
                lang={props.lang}
                dict={props.dict}
                addToDictionary={props.addToDictionary}
                defaultLanguage={props.defaultLanguage}
                changeLanguage={(language) => props.changeLanguage(language)}
                token={props.access_token}
                siteId={props.siteId}
                salesDriveId={props.salesDriveId}
                closeDrawer={closeOpportunityDrawer}
                onLoading={(v) => handleLoading(v)}
                clients={props.clients}
                salesMembers={salesMembers}
                updateClients={() => props.updateClients()}
                updateOpportunities={() => props.updateOpportunities()}
                notify={props.notify}
                reload={reloadSalesData}
                isOpenOpportunityDrawer={isOpenOpportunityDrawer}
            />

        </Drawer>
    )

    // Handle File Drawer
    let [isOpenFileDrawer, setIsOpenFileDrawer] = useState(false);
    let [isToBeCloned, setIsToBeCloned] = useState(false);
    let [selectedFileId, setSelectedFileId] = useState("");
    let [selectedFileName, setSelectedFileName] = useState("");
    let [selectedFileContent, setSelectedFileContent] = useState(Object);

    let closeFileDrawer = () => {
        setIsOpenFileDrawer(false)
    }

    let fileDrawer = (
        <Drawer
            classes={{ paper: classes.largePaper }}
            anchor="right"
            open={isOpenFileDrawer}
            onClose={(_, reason) => {
                if (reason !== "backdropClick") {
                    closeFileDrawer();
                }
            }}>
            <CvDetails
                dict={props.dict}
                addToDictionary={props.addToDictionary}
                lang={props.lang}
                defaultLanguage={props.defaultLanguage}
                changeLanguage={(language) => props.changeLanguage(language)}
                contentFile={selectedFileContent}
                fileId={selectedFileId}
                fileName={selectedFileName}
                token={props.access_token}
                siteId={props.siteId}
                salesDriveId={props.salesDriveId}
                webUrl={props.webUrl}
                onLoading={(v) => handleLoading(v)}
                closeDrawer={() => closeFileDrawer()}
                isHrMember={props.isHrMember}
                isAdminMember={props.isAdminMember}
                isSalesMember={props.isSalesMember}
                isCommercialCP={true} /*isCommercialCP === true when managing commercial CP*/
                isToBeCloned={isToBeCloned}
                opportunities={props.opportunities}
                userEmail={props.userEmail}
                allUsers={props.allUsers}
                notify={props.notify}
                reloadCommercial={reloadSalesData}
                commercialData={props.commercialData}
            />
        </Drawer>
    )

    let searchClientIdByName = (clientName) => {
        let client = props.clients.find(c => clientName === c.name)
        return client && client.id
    }

    let deleteCli = (c) => {
        let clientId = searchClientIdByName(c.client)
        if (clientId) {
            handleLoading(true)
            deleteClient(props.access_token, props.siteId, c.opportunities[0].details.clientId)
                .then(r => {
                    if (r.ok) {
                        props.notify("The client has been deleted !", "success")
                        setFiles(v => v.filter(el => el.client !== c.client))
                        reloadSalesData(searchKeys.current)
                        props.updateClients()
                    } else {
                        props.notify("An error has occurred !", "error")
                    }
                    handleLoading(false)
                })
        } else {
            props.notify("An error has occurred !", "error")
            handleLoading(false)
        }
    }

    let shiftOpportunity = (opportunity, clients) => {
        let i = clients.findIndex(el => el.client === opportunity.details.clientName)
        clients[i].opportunities = clients[i].opportunities.filter(el => el.name !== opportunity.name)

        return clients
    }

    let deleteOpp = (opportunity) => {
        if (opportunity.details.parentId) {
            handleLoading(true)
            deleteOpportunity(props.access_token, props.siteId, opportunity.details.parentId)
                .then(r => {
                    if (r.ok) {
                        props.notify("The opportunity has been deleted !", "success")
                        setFiles(shiftOpportunity(opportunity, files))
                        reloadSalesData(searchKeys.current)
                        props.updateOpportunities()
                    } else {
                        props.notify("An error has occurred !", "error")
                    }
                    handleLoading(false)
                })
        } else {
            props.notify("An error has occurred !", "error")
            handleLoading(false)
        }
    }

    let shiftCP = (file, clients) => {
        let cIndex = clients.findIndex(el => el.client === file.clientName)
        let oIndex = clients[cIndex].opportunities.findIndex(el => el.name === file.opportunityName)

        clients[cIndex].opportunities[oIndex].cvs = clients[cIndex].opportunities[oIndex].cvs.filter(el => el.id !== file.id)
        return clients
    }

    let deleteCP = (file) => {
        if (file) {
            handleLoading(true)
            deleteFile(props.access_token, props.siteId, file.id)
                .then(r => {
                    if (r.ok) {
                        props.notify("The Consultant Profile has been deleted !", "success")
                        setFiles(shiftCP(file, files))
                        reloadSalesData(searchKeys.current)
                    } else {
                        props.notify("An error has occurred !", "error")
                    }
                    handleLoading(false)
                })
        } else {
            props.notify("An error has occurred !", "error")
            handleLoading(false)
        }
    }

    let toggleOpportunityDrawer = (isOpen, opportunity) => {
        if (hasSalesFunctionalities) {
            handleLoading(true)
            setSelectedOpportunity(opportunity)
            setIsOpenOpportunityDrawer(true)
        }
    }

    let toggleFileDrawer = (isOpen, file, isToBeCloned) => {
        handleLoading(true)
        searchFileContentByFileId(props.access_token, props.siteId, file.id)
            .then(r => {
                if (r) {
                    setIsToBeCloned(isToBeCloned)
                    setSelectedFileId(file.id)
                    setSelectedFileName(file.name)
                    props.changeLanguage(getLanguageFromFileName(file.name))
                    if (isToBeCloned) {
                        r.SkillsPassport.LearnerInfo["opportunity"] = {
                            name: "",
                            id: "",
                            client: Object,
                        }
                    }
                    setSelectedFileContent(r)
                }
                handleLoading(false)
                setIsOpenFileDrawer(true)
            })
    }

    let handleSearch = async (v) => {
        handleLoading(true)
        searchKeys.current = (v);
        await reloadSalesData(v);
        handleLoading(false)
    }

    let infoArea = <div className={classes.infoBar}> Loading data ... </div>
    let searchArea = <div className={classes.searchArea}>
        <SearchData
            isDisabled={!isDataLoaded}
            pushedClass="search"
            search={handleSearch}
            searchkeys={searchKeys.current}
            tooltipTitle="Search Commercial Consultant Profile"
        />
    </div>
    let dataArea = isDataLoaded && <div className={classes.dataArea}>
        <AccTable data={files}
            onLoading={(v) => handleLoading(v)}
            editOpportunity={(opportunity) => toggleOpportunityDrawer(true, opportunity)}
            deleteCP={deleteCP}
            deleteOpportunity={(opportunity) => deleteOpp(opportunity)}
            deleteClient={(c) => deleteCli(c)}
            isVisibleSalesBtn={hasSalesFunctionalities}
            isAdminMember={props.isAdminMember}
            editFile={(v) => toggleFileDrawer(true, v, false)}
            cloneFile={(v) => toggleFileDrawer(true, v, true)}
            checkedList={checkedList}
            setCheckedList={setCheckedList}
            selectedItemIndex={findElementIndexInArray}
            setRowsPerPage={setRowsPerPage}
            rowsPerPage={rowsPerPage}
            page={page}
            setPage={setPage}
            access_token={props.access_token}
            siteId={props.siteId}
        />
    </div>

    return isDataLoaded ?
        <Aux>
            {searchArea}
            {dataArea}
            {commercialCvsBtnArea}
            {opportunityDrawer}
            {fileDrawer}
        </Aux>
        : infoArea
};

export default Element;